import React from 'react';
import { ArrowLeftIcon, ShieldCheckIcon } from 'lucide-react';
export function PrivacyPolicy() {
  return <main className="min-h-screen w-full bg-[#fcfbf7] px-5 py-10 text-[#344833] sm:px-8 sm:py-16" data-id="element-470" data-mp="v9wiqbisvpjc">
      <div className="mx-auto max-w-3xl" data-id="element-471" data-mp="qabcrh57qgx4">
        <a href="/" className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.12em] text-[#597050] transition-colors hover:text-[#30452e]" data-id="element-472" data-mp="qd5uv20r7pnd">
          <ArrowLeftIcon size={16} data-id="element-473" data-mp="1iz8tvgxou7oa" />
          VOLVER A CÓDIGO FITNESS™
        </a>

        <article className="mt-12 border border-[#e1e4da] bg-[#fffefa] p-7 shadow-[0_12px_35px_rgba(61,75,53,0.07)] sm:p-12" data-id="element-474" data-mp="1e1yup9khyhn9">
          <div className="flex items-center gap-3 text-[#66805c]" data-id="element-475" data-mp="197ulskro7zjj">
            <ShieldCheckIcon size={20} strokeWidth={1.5} aria-hidden="true" data-id="element-476" data-mp="157ampbnjelur" />
            <p className="text-xs font-bold tracking-[0.2em]" data-id="element-477" data-mp="21qrqn614cphv">
              INFORMACIÓN LEGAL
            </p>
          </div>
          <h1 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-478" data-mp="1wyqah90tyemk">
            Política de Privacidad
          </h1>

          <div className="mt-10 space-y-9 leading-8 text-[#5d6a59]" data-id="element-479" data-mp="a049inzc648n">
            <section data-id="element-480" data-mp="9zcd5axx02hb">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-481" data-mp="a1yjx8czedyh">
                Información que recopilamos
              </h2>
              <p className="mt-3" data-id="element-482" data-mp="9swmbxockpm">
                Podemos recopilar la información que proporcionas al realizar
                una compra, solicitar acceso o comunicarte con nosotros, como tu
                nombre, dirección de correo electrónico, información de
                facturación y los datos necesarios para entregar el producto
                digital. Los pagos son procesados por plataformas de pago
                externas; Código Fitness™ no almacena datos completos de
                tarjetas bancarias.
              </p>
            </section>

            <section data-id="element-483" data-mp="16ok2yv5kgxr1">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-484" data-mp="1bpzmgis3iw7b">
                Cómo utilizamos esta información
              </h2>
              <p className="mt-3" data-id="element-485" data-mp="1a93nnznl3sh5">
                Utilizamos los datos recopilados para procesar compras, entregar
                el contenido adquirido, responder consultas, brindar asistencia
                técnica, mejorar la experiencia del sitio y cumplir obligaciones
                legales o administrativas aplicables.
              </p>
              <p className="mt-3" data-id="element-486" data-mp="1sysd5d8o2gp4">
                No vendemos ni alquilamos información personal. Solo podremos
                compartir información con proveedores que intervengan en la
                operación del servicio —por ejemplo, plataformas de pago,
                alojamiento o entrega digital— cuando sea necesario para prestar
                el servicio.
              </p>
            </section>

            <section data-id="element-487" data-mp="2bptc419sec8o">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-488" data-mp="2bqbfriys3sqm">
                Protección de datos personales
              </h2>
              <p className="mt-3" data-id="element-489" data-mp="26wgonugugbhi">
                Aplicamos medidas razonables de organización y seguridad para
                proteger los datos personales frente a accesos no autorizados,
                pérdida, alteración o divulgación indebida. Ningún método de
                transmisión por internet o almacenamiento electrónico puede
                garantizar seguridad absoluta, pero procuramos utilizar medios
                apropiados para proteger la información bajo nuestro control.
              </p>
            </section>

            <section data-id="element-490" data-mp="hdck0xzoeepo">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-491" data-mp="hcuhxkqc169u">
                Uso de cookies
              </h2>
              <p className="mt-3" data-id="element-492" data-mp="m54dbga7uyji">
                Este sitio y los servicios de terceros utilizados para su
                funcionamiento pueden emplear cookies o tecnologías similares
                para recordar preferencias, medir el rendimiento y facilitar una
                navegación adecuada. Puedes administrar o bloquear cookies desde
                la configuración de tu navegador; algunas funciones del sitio
                podrían verse limitadas si las desactivas.
              </p>
            </section>

            <section data-id="element-493" data-mp="hgpokm9ijr1g">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-494" data-mp="w76pm4i8kext">
                Seguridad de la información
              </h2>
              <p className="mt-3" data-id="element-495" data-mp="r9eqapf9hqjl">
                El acceso a la información se limita a lo necesario para operar,
                entregar y dar soporte a Código Fitness™. También recomendamos
                no compartir los enlaces, archivos o credenciales de acceso que
                recibas después de tu compra.
              </p>
            </section>

            <section data-id="element-496" data-mp="8i5c42ujqdlo">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-497" data-mp="8hm3xdup73ku">
                Derechos del usuario
              </h2>
              <p className="mt-3" data-id="element-498" data-mp="1oukergfp067d">
                De acuerdo con la normativa que resulte aplicable, puedes
                solicitar acceso, corrección, actualización o eliminación de tus
                datos personales, así como plantear preguntas sobre el
                tratamiento de tu información. Algunas solicitudes pueden estar
                sujetas a obligaciones legales de conservación de registros.
              </p>
            </section>

            <section className="border-l-2 border-[#91a783] bg-[#f4f7ef] px-5 py-6" data-id="element-499" data-mp="1mh78czaqc419">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-500" data-mp="2a71e6wwmssc0">
                Consultas de privacidad
              </h2>
              <p className="mt-3" data-id="element-501" data-mp="2f6e3rpew0dia">
                Para realizar una consulta o solicitud relacionada con tu
                privacidad, utiliza el canal de soporte indicado en la
                confirmación de compra o en la plataforma desde la que accediste
                a Código Fitness™. Incluye la información necesaria para
                identificar tu compra y atender tu solicitud.
              </p>
            </section>
          </div>
        </article>

        <p className="mt-8 text-center text-xs text-[#7a8574]" data-id="element-502" data-mp="37sm6c5n3fbu4">
          © 2026 Código Fitness™. Todos los derechos reservados.
        </p>
      </div>
    </main>;
}